import { colors as typographyColors } from 'shared_DEPRECATED/components/Typography/Typography';

export const mapIconTypographyColor = {
  green: typographyColors.green,
  orange: typographyColors.orange,
  gray: typographyColors.gray,
};
